import React from 'react';
import { Pickaxe, MapPin, Layers, TrendingUp } from 'lucide-react';

const points = [
  {
    Icon: Pickaxe,
    title: 'Industrial & Mining Technology Exposure',
    desc: 'ADELZONE is in active engagement with MST Global\'s AXON platform — world-leading underground connectivity and automation technology deployed in mining operations globally. We understand the OT/IT environments your clients operate in.',
  },
  {
    Icon: MapPin,
    title: 'Local Presence, International Standards',
    desc: 'Based in Accra with deep knowledge of Ghana\'s business environment, yet operating to international standards and partnering with global technology leaders to deliver world-class solutions locally.',
  },
  {
    Icon: Layers,
    title: 'End-to-End Capability',
    desc: 'From infrastructure audit to software development to ongoing support — ADELZONE covers the full technology stack so you work with one trusted partner, not a fragmented chain of vendors.',
  },
  {
    Icon: TrendingUp,
    title: 'Phased, Scalable Approach',
    desc: 'Every engagement is structured in phases — delivering value quickly while building toward a complete digital infrastructure. No big-bang investments, no unnecessary risk, no vendor lock-in.',
  },
];

const techStack = [
  { icon: '☁️', name: 'Microsoft Azure', desc: 'Cloud infrastructure & enterprise analytics' },
  { icon: '🔗', name: 'IoT & Industrial Connectivity', desc: 'Sensor integration, LoRa, BLE, edge computing' },
  { icon: '🛡️', name: 'Enterprise Network Security', desc: 'Firewall, VPN, endpoint & data protection' },
  { icon: '⚙️', name: 'ERP & Business Systems', desc: 'Odoo, custom integrations, API architecture' },
  { icon: '📡', name: 'High-Bandwidth Fibre & Wi-Fi', desc: 'Multi-site network design & deployment' },
  { icon: '📊', name: 'Business Intelligence', desc: 'Real-time dashboards & operational analytics' },
];

export default function WhyUs() {
  return (
    <section id="why" style={{ padding: '100px 5%', background: 'var(--navy-mid)' }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
        gap: '5rem',
        alignItems: 'start',
      }}>
        {/* Left column */}
        <div>
          <div style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--electric)', marginBottom: '0.8rem' }}>
            Why ADELZONE
          </div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(1.9rem,3.5vw,2.8rem)', fontWeight: 700, color: 'var(--white)', letterSpacing: '-0.8px', lineHeight: 1.15, marginBottom: '1rem' }}>
            Built for Ghana's most demanding industries
          </h2>
          <p style={{ color: 'var(--slate)', fontSize: '1rem', maxWidth: '480px', lineHeight: 1.7, marginBottom: '2.5rem' }}>
            We don't just deliver IT solutions — we build long-term technology partnerships grounded in the operational realities of your sector.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.8rem' }}>
            {points.map((p, i) => (
              <div key={i} style={{ display: 'flex', gap: '1.1rem' }}>
                <div style={{
                  width: 44, height: 44, borderRadius: '10px', flexShrink: 0,
                  background: 'rgba(0,180,216,0.1)',
                  border: '1px solid rgba(0,180,216,0.2)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'var(--electric)',
                }}>
                  <p.Icon size={20} />
                </div>
                <div>
                  <div style={{ fontSize: '0.97rem', fontWeight: 600, color: 'var(--white)', marginBottom: '0.3rem' }}>{p.title}</div>
                  <div style={{ fontSize: '0.87rem', color: 'var(--slate)', lineHeight: 1.65 }}>{p.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right column — tech stack card */}
        <div style={{
          background: 'var(--card-bg)',
          border: '1px solid var(--card-border)',
          borderRadius: '16px', padding: '2.2rem',
        }}>
          <div style={{
            fontSize: '0.72rem', fontWeight: 700, letterSpacing: '1.5px',
            textTransform: 'uppercase', color: 'var(--slate-light)',
            marginBottom: '1.5rem',
          }}>
            Technology Ecosystem
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            {techStack.map((t, i) => (
              <div key={i} style={{
                display: 'flex', alignItems: 'center', gap: '1rem',
                background: 'rgba(0,180,216,0.04)',
                border: '1px solid rgba(0,180,216,0.1)',
                borderRadius: '8px', padding: '0.8rem 1rem',
              }}>
                <div style={{ fontSize: '1.3rem', width: 32, textAlign: 'center', flexShrink: 0 }}>{t.icon}</div>
                <div>
                  <div style={{ fontSize: '0.88rem', fontWeight: 500, color: 'var(--white)' }}>{t.name}</div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--slate)', marginTop: '1px' }}>{t.desc}</div>
                </div>
              </div>
            ))}
          </div>

          {/* MST Global callout */}
          <div style={{
            marginTop: '1.5rem',
            padding: '1rem 1.2rem',
            background: 'rgba(244,166,35,0.06)',
            border: '1px solid rgba(244,166,35,0.2)',
            borderRadius: '10px',
            borderLeft: '3px solid var(--gold)',
          }}>
            <div style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--gold)', letterSpacing: '0.5px', marginBottom: '0.3rem' }}>
              ⛏ INDUSTRIAL PARTNERSHIP
            </div>
            <div style={{ fontSize: '0.82rem', color: 'var(--text-body)', lineHeight: 1.55 }}>
              In active discussions with <strong style={{ color: 'var(--white)' }}>MST Global</strong> — provider of the AXON underground connectivity & automation platform used in mining operations worldwide.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
